'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _BaseField = require('uniforms/BaseField');

var _BaseField2 = _interopRequireDefault(_BaseField);

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmitField = function SubmitField(_ref, _ref2) {
    var _ref2$uniforms = _ref2.uniforms,
        error = _ref2$uniforms.error,
        disabled = _ref2$uniforms.state.disabled;
    var inputRef = _ref.inputRef,
        value = _ref.value,
        props = (0, _objectWithoutProperties3.default)(_ref, ['inputRef', 'value']);
    return _react2.default.createElement(
        _button2.default,
        (0, _extends3.default)({
            disabled: !!(error || disabled),
            htmlType: 'submit',
            ref: inputRef,
            type: 'primary'
        }, props),
        value
    );
};

SubmitField.contextTypes = _BaseField2.default.contextTypes;
SubmitField.defaultProps = { value: 'Submit' };

exports.default = SubmitField;


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-antd/SubmitField.js
// module id = 633
// module chunks = 35783957827783 65974612472484